
const INITIAL_STATE = {}

const custGprPcgReducer = (state = INITIAL_STATE, action) => {
        switch (action.type) {
                case "GET_DATA_CustGprPcg":
                        return { ...state, listacustGprPcg: action.payload.data }
                case "GET_DATA_LSTRVD":
                        return { ...state, ListaTdsRevendas: action.payload.data }
                default:
                        return state
        }
}
export default custGprPcgReducer;
